<!--TOOD replace inline style https://trello.com/c/XpKJZqE7/9010-f-ca-address-inline-styles-in-onboarding-->
<tidy-wrapper>
  <tidy-row [align]="'center'">
    <tidy-text
      [title]="'Get it Done Right'" />
  </tidy-row>

  <tidy-row class="extra-bottom-padding" [align]="'center'">
    <tidy-text
      [body]="'Create a digital To-Do List and share it with any Pro for free!'" />
  </tidy-row>

  <tidy-card style="width:70%; margin-left: auto; margin-right: auto; padding: 10px">
    <tidy-row class="vertical-align-center">
      <tidy-image
        [src]="'assets/img/icons/rooms/kitchen.svg'"
        class="body-size" />
      <tidy-text
        [header]="'Kitchen'" />
    </tidy-row>
    <ion-skeleton-text />
    <ion-skeleton-text />
  </tidy-card>
  <tidy-card style="width:70%; margin-left: auto; margin-right: auto; padding: 10px">
    <tidy-row class="vertical-align-center">
      <tidy-image
        [src]="'assets/img/icons/rooms/bathroom_1.svg'"
        class="body-size" />
      <tidy-text
        [header]="'Bathroom'" />
    </tidy-row>
    <ion-skeleton-text />
    <ion-skeleton-text />
  </tidy-card>
  <tidy-card style="width:70%; margin-left: auto; margin-right: auto; padding: 10px">
    <tidy-row class="vertical-align-center">
      <tidy-image
        [src]="'assets/img/icons/rooms/laundry.svg'"
        class="body-size" />
      <tidy-text
        [header]="'Laundry Room'" />
    </tidy-row>
    <ion-skeleton-text />
    <ion-skeleton-text />
  </tidy-card>

  @if (errorMessage) {
    <tidy-error-message
      [text]="errorMessage" />
  }

  <tidy-row>
    <tidy-button
      [text]="'Create To-Do List in 1 Minute'"
      [action]="handleOnboardingSelection.bind(this, 'create_list')"
      class="primary full-width"
      [disabled]="buttonsDisabled" />
  </tidy-row>

  <tidy-row>
    <tidy-button
      [text]="'Have Concierge Add For Me'"
      [action]="boundGoToAddConciergeTask"
      class="secondary full-width"
      [disabled]="buttonsDisabled" />
  </tidy-row>

  <tidy-row [align]="'center'">
    <tidy-text
      [body]="'Use Most Popular'"
      (action)="handleOnboardingSelection('most_popular')"
      class="link"
      [class.link-disabled]="buttonsDisabled" />
  </tidy-row>
</tidy-wrapper>
